import { BaseEntity } from '../../../models';
import { Usuario } from '../../usuario';
import { lancamentoManual } from '../atividade-lancamento';

export class AtividadeChecklistItem implements BaseEntity {
    readonly id: number;
    idAtividade: number;
    sequencia: number;
    lancamento: number;
    nome: string;
    concluido: boolean;
    dataConclusao: Date;
    idUsuarioConclusao: number;
    usuarioConclusao: Usuario;

    constructor(idAtividade: number, lancamento: number = lancamentoManual.id) {
        this.idAtividade = idAtividade;
        this.lancamento = lancamento;
    }
}
